import { createAction, props } from "@ngrx/store";
import { RiskAssessmentSegment } from "../risk-assessments.reducer";

export const setRiskAssessmentSegment = createAction(
  "[RiskAssessment Segment] Set RiskAssessment Segment",
  props<{ segment: RiskAssessmentSegment }>()
);
